import { Component, signal } from '@angular/core';
import { BackgroundComponent } from '../../../shared/pages/background/background.component';
import { RouterLink } from '@angular/router';


@Component({
  selector: 'app-login-page',
  imports: [BackgroundComponent, RouterLink],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css'
})
export class LoginPageComponent {
  public showPassword = signal(false);

  constructor() { }

  togglePasswordVisibility() {
    this.showPassword.update(value => !value);
  }

}